import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { MenuService } from '@app/menu/services/menu.service';
import { PageHeadingData } from '@app/shared/components/page-heading/page-heading-data';
import { PageHeadingPostfixDirective } from '@app/shared/components/page-heading/page-heading-postfix.directive';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-page-heading',
  templateUrl: './page-heading.component.html',
  styles: [],
  standalone: false,
})
export class PageHeadingComponent {
  @ContentChild(PageHeadingPostfixDirective, { read: TemplateRef, static: true })
  postfix: TemplateRef<any>;

  @Input()
  hidePostfix: boolean = true;

  @Input() headingClass: string;

  public data$: Observable<PageHeadingData> = this.menuService.menuData$.pipe(
    map((menu) => {
      const data: PageHeadingData = {
        name: '',
        showEndUser: false,
        showEnterprise: false,
        showServiceProvider: false,
      };

      if (menu.activeUserLevels.isEndUser) {
        if (this.authenticationService.userIsEndUser() === false) {
          data.name = menu.userId;
          data.showEndUser = true;
        }
      } else if (menu.activeUserLevels.isEnterprise) {
        if (this.authenticationService.userIsEnterpriseAdmin() === false) {
          data.name = menu.enterpriseId;
          data.showEnterprise = true;
        }
      } else if (
        menu.activeUserLevels.isServiceProvider &&
        this.authenticationService.userIsServiceProviderAdmin() === false
      ) {
        data.name = menu.serviceProviderId;
        data.showServiceProvider = true;
      }

      return data;
    }),
    untilDestroyed(this)
  );

  constructor(
    private authenticationService: AuthenticationService,
    private menuService: MenuService
  ) {}
}
